module.exports = __webpack_public_path__ + "fonts/zpix.4f6b6b95.ttf";